import { CheckCircle2, Send, XCircle } from "lucide-react";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { NotificacaoTesteResultado } from "@/services/api/notificacao-teste.service";

interface ResultadoEnvioPanelProps {
  resultado: NotificacaoTesteResultado | null;
  /** Rótulo humano do destino — no INBOX o destino é um `identityId`, que não diz nada. */
  labelDestino?: (destino: string) => string | undefined;
}

export function ResultadoEnvioPanel({ resultado, labelDestino }: ResultadoEnvioPanelProps) {
  if (!resultado) {
    return (
      <div className="flex h-full min-h-40 flex-col items-center justify-center text-center text-muted-foreground">
        <Send className="mb-3 h-8 w-8 opacity-40" />
        <p className="text-sm">O resultado do envio aparece aqui.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-4 text-sm">
        <span className="font-medium">Total: {resultado.total}</span>
        <span className="text-emerald-600 dark:text-emerald-400">
          Enviados: {resultado.enviados}
        </span>
        <span className="text-destructive">Falhas: {resultado.falhas}</span>
      </div>

      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-10" />
            <TableHead>Destino</TableHead>
            <TableHead>Detalhe</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {resultado.resultados.map((r, i) => (
            <TableRow key={`${r.destino}-${i}`}>
              <TableCell>
                {r.ok ? (
                  <CheckCircle2 className="h-4 w-4 text-emerald-600 dark:text-emerald-400" />
                ) : (
                  <XCircle className="h-4 w-4 text-destructive" />
                )}
              </TableCell>
              <TableCell className="font-mono text-xs">
                {labelDestino?.(r.destino) ?? r.destino}
              </TableCell>
              <TableCell className="text-xs text-muted-foreground">
                {r.ok ? "Enviado" : (r.erro ?? "Falha ao enviar")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
